export default __webpack_public_path__ + "static/media/682.a7d15f3c.png";